<!-- Spinner -->
<div class="spinner-overlay" *ngIf="dataService.progressBarActiveForSlider">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>
<ng-container *ngIf="dashboardReady">
    <div class="w-100 h-100 d-flex flex-column gap-5 px-0 px-md-4 px-lg-5 py-2">

        <div class="d-flex justify-content-around gap-3 flex-wrap">
            <div style="max-width: 250px;"
                class="alert alert-light w-100 shadow rounded-4 d-flex align-items center flex-column justify-content-center text-center"
                (click)="openAllTasks()">
                <span class="insightDahsboardCardValue">{{dashBoardDataInComplete + dashBoardDataComplete}}</span>
                <span class="insightDahsboardCardTitle">TOTAL JOBS</span>
            </div>

            <div style="max-width: 250px;"
                class="alert alert-light w-100 shadow rounded-4 d-flex align-items center flex-column justify-content-center text-center"
                (click)="openInProgressTasks()">
                <span class="insightDahsboardCardValue">{{dashBoardDataInComplete}}</span>
                <span class="insightDahsboardCardTitle">JOBS IN PROCESS</span>
            </div>

            <div style="max-width: 250px;" *ngIf="role == 'doctor'"
                class="alert alert-light w-100 shadow rounded-4 d-flex align-items center flex-column justify-content-center text-center"
                (click)="openDeliveredTasks()">
                <span class="insightDahsboardCardValue">{{dashBoardDataDelivered}}</span>
                <span class="insightDahsboardCardTitle">JOBS DELIVERED</span>
            </div>

            <div style="max-width: 250px;"
                class="alert alert-light w-100 shadow rounded-4 d-flex align-items center flex-column justify-content-center text-center"
                (click)="openCompletedTasks()">
                <span class="insightDahsboardCardValue">{{dashBoardDataComplete}}</span>
                <span class="insightDahsboardCardTitle">JOBS COMPLETED</span>
            </div>
        </div>
        <div class="w-100 d-flex flex-column gap-1">
            <span class="fadedTextChart" >Date Chart</span>
            <div class="p-2 p-md-4 p-lg-5 flex-column gap-3 rounded-4 shadow"
                style="backdrop-filter: blur(10px);background: rgba(255,255,255,0.8);">
                <app-bar-chart></app-bar-chart>

            </div>
            <div class="w-100 mb-4">
            </div>
        </div>
    </div>
</ng-container>